export default "__VITE_ASSET__BG3EQti6__"